/**
 * MINI CROSSWORD PUZZLE DATA
 *
 * How to customize this puzzle:
 * 1. Edit the clues and answers below with your own memories
 * 2. Keep answers short (3-7 letters work best for a mini)
 * 3. Update `gridSize` and `gridLayout` if you want a larger puzzle (currently 12x12)
 * 4. Make sure across/down words intersect at matching letters!
 *
 * Tips for relationship crossword:
 * - Use significant dates (anniversary month, where you met, etc.)
 * - Places you've been
 * - Pet names or nicknames
 * - Favorite activities
 * - Inside jokes
 */

export const gridSize = 12;

// Grid layout: true = black square, false = white square
export const gridLayout = [
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
  ],
  [true, true, true, true, true, true, true, true, true, true, false, false],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
  ],
  [true, true, true, true, true, true, true, true, false, true, false, false],
  [
    false,
    false,
    false,
    false,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
  ],
  [true, true, true, true, true, true, true, true, true, true, true, false],
  [false, false, false, false, true, true, true, true, true, true, true, false],
  [true, true, true, true, true, true, true, true, true, true, true, false],
  [true, true, true, true, true, true, true, true, true, true, true, false],
  [true, true, true, true, true, true, true, true, true, true, true, false],
  [true, true, true, true, true, true, true, true, true, true, true, true],
];

export const acrossClues = [
  {
    number: 1,
    clue: "What is this gift celebrating?",
    answer: "ANNIVERSARY",
    row: 0,
    col: 0,
    length: 11,
  },
  {
    number: 2,
    clue: "Our anniversary (11/14/21)",
    answer: "NOV1421",
    row: 2,
    col: 0,
    length: 7,
  },
  {
    number: 3,
    clue: "Your nickname for me",
    answer: "BULL",
    row: 4,
    col: 0,
    length: 4,
  },
  {
    number: 4,
    clue: "What you order every time we go out",
    answer: "PASTA",
    row: 5,
    col: 0,
    length: 5,
  },
  {
    number: 5,
    clue: "Our song",
    answer: "3005",
    row: 7,
    col: 0,
    length: 4,
  },
];

export const downClues = [
  {
    number: 6,
    clue: "Only pretty cute?",
    answer: "YEAH",
    row: 0,
    col: 10,
    length: 4,
  },
  {
    number: 7,
    clue: "Your first time turning into Godzilla",
    answer: "UBER",
    row: 2,
    col: 8,
    length: 4,
  },
  {
    number: 8,
    clue: "Where I asked you to be my girlfriend",
    answer: "DISNEYLAND",
    row: 1,
    col: 11,
    length: 10,
  },
];

// Generate solution grid based on answers
export const generateSolutionGrid = () => {
  const grid = Array(gridSize)
    .fill(null)
    .map(() => Array(gridSize).fill(null));

  // Mark black squares
  for (let row = 0; row < gridSize; row++) {
    for (let col = 0; col < gridSize; col++) {
      if (gridLayout[row][col]) {
        grid[row][col] = { isBlock: true };
      }
    }
  }

  // Fill in across answers
  acrossClues.forEach((clue) => {
    for (let i = 0; i < clue.answer.length; i++) {
      const row = clue.row;
      const col = clue.col + i;
      if (!grid[row][col]) {
        grid[row][col] = {};
      }
      grid[row][col].letter = clue.answer[i];
      if (i === 0) {
        grid[row][col].number = clue.number;
      }
    }
  });

  // Fill in down answers
  downClues.forEach((clue) => {
    for (let i = 0; i < clue.answer.length; i++) {
      const row = clue.row + i;
      const col = clue.col;
      if (!grid[row][col]) {
        grid[row][col] = {};
      }
      grid[row][col].letter = clue.answer[i];
      if (i === 0 && !grid[row][col].number) {
        grid[row][col].number = clue.number;
      }
    }
  });

  return grid;
};
